import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Typography, Collapse } from 'seagull';
import { ChevronDown, ChevronUp } from 'seagull/icons';
import styles from './ServicesSection.module.scss';
export default function BillingControlSection(props) {
    const { title, hidden, children, testId } = props, rest = _object_without_properties(props, [
        "title",
        "hidden",
        "children",
        "testId"
    ]);
    const [shown, setShown] = useState(true);
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({}, rest), {
        hidden: hidden,
        "data-testid": testId,
        children: [
            /*#__PURE__*/ _jsxs("button", {
                className: styles.recurrencePeriod,
                onClick: ()=>setShown(!shown),
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        as: "span",
                        children: title
                    }),
                    shown ? /*#__PURE__*/ _jsx(ChevronUp, {}) : /*#__PURE__*/ _jsx(ChevronDown, {})
                ]
            }),
            /*#__PURE__*/ _jsx(Collapse, {
                in: shown,
                children: /*#__PURE__*/ _jsx("ul", {
                    children: children
                })
            })
        ]
    }));
}
